import React from 'react';
import Diamond from './Diamond';

export const CTABlock = ({ className = '' }) => {
  return (
    <div className={`cta-block ${className}`} data-testid="cta-block">
      {/* Primary CTA */}
      <a 
        href="https://book.stripe.com/14A5kE81ddOP7wq9UycMM0o"
        target="_blank"
        rel="noopener noreferrer"
        className="cta-block-primary no-underline"
        data-testid="cta-primary"
        onClick={() => {
          window.gtag('event', 'booking_click', {
            event_category: 'conversion',
            event_label: 'Binary_Solve_300'
          });
        }}
      >
        <span className="cta-block-primary-text">
          <Diamond color="white" size="sm" />
          Start with a Binary Solve
        </span>
        <span className="cta-block-sub">$300</span>
      </a>
      
      {/* Secondary CTA */}
      <a 
        href="https://app.usemotion.com/meet/marco-hansell/binaryconsult"
        target="_blank"
        rel="noopener noreferrer"
        className="cta-block-secondary no-underline"
        data-testid="cta-secondary"
      >
        <span>Not sure yet?</span>
        <span style={{ color: 'var(--color-near-black)', fontWeight: 700 }}>
          Free 15-min call
        </span>
      </a>
    </div>
  );
};

export default CTABlock;
